<script>
export default {
    filters: {
        maximum: function (value) {
            const MAX_RESULTS = 10;
            return value.slice(0, MAX_RESULTS);
        },
        maximumLev: function (value) {
            const MAX_RESULTS = 3;
            return value.slice(0, MAX_RESULTS);
        }
    },

    computed: {
        find() {
            const vm = this;
            return vm.$search.find(vm.searchKeyword.toLowerCase().trim());
        },
        findByLev() {
            const vm = this;
            // return [];
            return vm.$search.findByLev(vm.searchKeyword.toLowerCase().trim(), 3);
        },

        results() {
            const vm = this;
            return vm.searchResults(vm.searchKeyword.toLowerCase().trim());
        },
    },

    methods: {

        highlitAutocomplete(keyword, recommandation){
            let response = recommandation;
            if(recommandation.indexOf(keyword) !== -1){
                response = recommandation.replace(keyword, '');
                response = keyword + "<strong>" + response + "</strong>";
            }
            return response;
        },


        contentForData(data) {
            let language = this.$i18n.locale;
            let application = $application[language];
            let page = application.pages.getBySlug(data.slug);
            let content = page[data.type][data.key];
            return content;
        },

        searchResults(searchKeyword) {
            const vm = this;

            let results = searchKeyword.length >= 3
                    ? vm.$search.autocomplete(searchKeyword)
                    : [];

            if (results && results.length) {
                results = results.sort((a, b) => (a.word > b.word) ? 1 : -1);
                return results
            } else {
                return []
            }
        },

        TotalResults(searchResults) {
            const vm = this;

            let data = [];
            for (let result of searchResults) {
                for (let d of result.data) {
                    let content = vm.contentForData(d);
                    if (d.type === 'richmedia' && (content.type === "images" || content.type === "html5video")) {
                        data.push({...{}, ...d});
                    } else {
                        data.push({...{}, ...d});
                    }
                }
            }

            return data;
        },

        ContentResults(searchResults) {
            const vm = this;

            let data = [];
            for (let result of searchResults) {
                for (let d of result.data) {
                    if (d.type === 'content') {
                        data.push({...{}, ...d});
                    }
                }
            }

            data = data.sort(function(a,b){
                return a.slug < b.slug ? -1 : 1;
            });

            return data;
        },

        ImagesResults(searchResults) {
            const vm = this;

            let data = [];
            for (let result of searchResults) {
                for (let d of result.data) {
                    let content = vm.contentForData(d);

                    if (d.type === 'images' || (d.type === 'richmedia' && content.type === 'image')) {
                        data.push({...{}, ...d});
                    }
                }
            }

            data = data.sort(function(a,b){
                return a.slug < b.slug ? -1 : 1;
            });

            return data;
        },


        RichmediaResults(searchResults) {
            const vm = this;

            let data = [];
            for (let result of searchResults) {
                for (let d of result.data) {
                    let content = vm.contentForData(d);

                    if (d.type === 'richmedia' && content.type === 'html5video') {
                        data.push({...{}, ...d});
                    }
                }
            }

            data = data.sort(function(a,b){
                return a.slug < b.slug ? -1 : 1;
            });

            return data;
        },


        async recoverKeywordsFromPages() {

            const vm = this;

            const language = this.$i18n.locale;
            const application = window.$application;
            const pages = application[language].pages.getAll();


            for (let page of pages) {


                ['content', 'images', 'richmedia'].forEach(await function (key_type) {


                    for (let idx_type in page[key_type] || {}) {
                        let value_type = page[key_type][idx_type];


                        // alt_keywords
                        let alt_keywords = value_type.alt || '';
                        if (typeof [] === typeof alt_keywords) {
                            if (alt_keywords.hasOwnProperty('length')) {
                                alt_keywords = alt_keywords.join(' ');
                            } else {
                                console.err('alt_keywords', data);
                            }
                        }

                        // title_keywords
                        let title_keywords = value_type.title || '';
                        if (typeof [] === typeof title_keywords) {
                            if (title_keywords.hasOwnProperty('length')) {
                                title_keywords = title_keywords.join(' ');
                            } else {
                                console.err('title_keywords', data);
                            }
                        }

                        // text_keywords
                        let text_keywords = value_type.text || '';
                        if (typeof [] === typeof text_keywords) {
                            if (text_keywords.hasOwnProperty('length')) {
                                text_keywords = text_keywords.join(' ');
                            } else {
                                console.err('text_keywords', data);
                            }
                        }

                        // content_keywords
                        let content_keywords = value_type.content || '';
                        if (typeof [] === typeof content_keywords) {
                            if (content_keywords.hasOwnProperty('length')) {
                                content_keywords = content_keywords.join(' ');
                            } else {
                                console.err('content_keywords', data);
                            }
                        }


                        // join keywords
                        let keywords = [
                            alt_keywords,
                            title_keywords,
                            text_keywords,
                            content_keywords,
                        ].join(' ');

                        // remove tags si &copy; gen
                        keywords = keywords
                                .replaceAll(/(<([^>]+)>)/ig, '', '')
                                .replaceAll(/(\&([\w]+)\;)/ig, '', '');

                        // remove all ce nu e litera sau numar, inclusiv newline return sau tab
                        // keywords = keywords
                        //         .normalize('NFD')
                        //         .replaceAll(new RegExp(/[^\u0300-\u036f\w\d\s\’]/, 'g'), ' ')
                        //         .replaceAll(new RegExp(/[\n\r\t]/, 'g'), ' ');


                        keywords = keywords
                                .replaceAll(new RegExp(/[^ÁÉÍÓÚáéíóúâêîôûàèìòùÇç\w\d\s\’]/, 'g'), ' ')
                                .replaceAll(new RegExp(/[\n\r\t]/, 'g'), ' ');

                        // formatare string
                        keywords = keywords
                                .replaceAll(/\s{2,}/g, ' ')
                                .trim()
                                .toLowerCase();

                        // separa in cuvinte
                        keywords = keywords.split(' ');

                        // pastreaza o singura varianta a cuvantului
                        keywords = keywords.filter(function (v, i, a) {
                            return v !== '' && a.indexOf(v) === i && v.length >= 3;
                        });

                        // populeaza dictionarul
                        for (let word of keywords) {

                            let data = {
                                slug: page.slug,

                                thumb: value_type.thumb,

                                type: key_type, // content/images/richmedia
                                key: idx_type, // key pentru a regasi in [type][key],

                                src: value_type.src || '',
                                word: word,
                                phrase: '[...] ' + word + ' [...]',
                            };

                            vm.$search.insert(word, data);
                        }


                        // console.log(keywords);


                    }
                })
            }


        }
    }
}
</script>
